import { render } from "./EvaluationDetailView.vue?vue&type=template&id=a0c9256e"
import script from "./EvaluationDetailView.vue?vue&type=script&lang=js"
export * from "./EvaluationDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__